import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Checkbox from "@cloudscape-design/components/checkbox";
import Icon from "@cloudscape-design/components/icon";

const STORAGE_KEY = "idp-demo-welcome-dismissed";

function WelcomeModal() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));
  const [dontShow, setDontShow] = useState(false);

  const handleDismiss = () => {
    if (dontShow) {
      localStorage.setItem(STORAGE_KEY, "true");
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Modal
      visible={visible}
      onDismiss={handleDismiss}
      header={t("venue.help.welcome.title")}
      size="large"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs" alignItems="center">
            <Checkbox checked={dontShow} onChange={({ detail }) => setDontShow(detail.checked)}>
              {t("venue.help.welcome.dontShowAgain")}
            </Checkbox>
            <Button variant="primary" onClick={handleDismiss}>
              {t("venue.help.welcome.getStartedButton")}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="l">
        <Box variant="p">{t("venue.help.welcome.intro")}</Box>

        <Box variant="h3">{t("venue.help.welcome.features_title")}</Box>

        <SpaceBetween size="s">
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <div style={{ flexShrink: 0, paddingTop: "2px" }}>
              <Icon name="settings" />
            </div>
            <Box>{t("venue.help.welcome.feature_templates")}</Box>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <div style={{ flexShrink: 0, paddingTop: "2px" }}>
              <Icon name="upload" />
            </div>
            <Box>{t("venue.help.welcome.feature_upload")}</Box>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <div style={{ flexShrink: 0, paddingTop: "2px" }}>
              <Icon name="file" />
            </div>
            <Box>{t("venue.help.welcome.feature_formats")}</Box>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <div style={{ flexShrink: 0, paddingTop: "2px" }}>
              <Icon name="edit" />
            </div>
            <Box>{t("venue.help.welcome.feature_custom")}</Box>
          </div>
        </SpaceBetween>

        <Box variant="p" color="text-body-secondary">
          {t("venue.help.welcome.getStarted")}
        </Box>
      </SpaceBetween>
    </Modal>
  );
}

export default WelcomeModal;
